/* eslint-disable react/no-danger */
/* eslint-disable  react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { cloneDeep, isNil } from 'lodash';
import Loader from '../../components/Loader';
import SRP from '../../components/SRP';
import Controls from '../../components/Controls';
import StandAloneButtons from '../../components/StandAloneButtons';
import BYOButton from '../../components/BYOButton';
import * as carsActions from '../../redux/actions/cars';
import * as optionsActions from '../../redux/actions/options';
import { selectorCars, selectorCar, selectorFetching } from '../../redux/selectors/cars';
import { selectorWebsite, selectorDealer } from '../../redux/selectors/options';
import { selectorError } from '../../redux/selectors/error';
import styles from './Page.scss';

const defaultParams = {
  clientType: 'online',
  condition: ['New', 'Used', 'CPO'],
  current: 1,
  feedViewId: null,
  financeType: 'purchase',
  limit: 20,
  online: true,
};

const Page = (props) => {
  const { actions, website, dealer, fetching, cars, car, error, ...rest } = props;
  const params = cloneDeep(defaultParams);
  
  const [controlWebsiteId, setControlWebsiteId] = useState(null);
  const [controlCondition, setControlCondition] = useState(null);
  const [controlVIN, setControlVIN] = useState(null);
  const [controlPageTemplate, setControlPageTemplate] = useState('SRP');

  const mapQueryStringParams = () => {
    const qsArray = props.location.search.split('&');
    qsArray.forEach((p) => {
      p = p.replace('?', '');
      p = p.split('=');
      switch (p[0]) {
        case 'websiteId':
          if (p[1]) {
            setControlWebsiteId(p[1]);
          }
          break;
        case 'condition':
          if (p[1]) {
            setControlCondition(p[1]);
          }
          break;
        case 'vin':
          if (p[1]) {
            setControlVIN(p[1]);
          }
          break;
        case 'pageTemplate':
          if (p[1]) {
            setControlPageTemplate(p[1]);
          }
          break;
        default:
          // noOp
      }
    });
  };

  useEffect(() => {
    mapQueryStringParams();
    generateScriptTag();
  }, []);

  useEffect(() => {
    if (controlWebsiteId) {
      actions.getWebsite(controlWebsiteId);
    }
  }, [controlWebsiteId]);

  useEffect(() => {
    if (controlVIN && dealer) {
      actions.getCar(controlVIN);
    }
  }, [controlVIN, dealer]);

  useEffect(() => {
    if (website?.id) {
      const script = document.getElementById('prodigyButtonGroupAgent');
      const baseUrl = process.env.REACT_APP_BASE_URL;
      const envType =
        process.env.REACT_APP_ENV === 'development' ? 'local' : process.env.REACT_APP_ENV;
      script.src = `${baseUrl}/priceButtonGroupAgent.v1.0.js`;
      script.setAttribute('envType', envType);
      script.setAttribute('websiteId', website.id);
      script.setAttribute('bustCache', true);
    }
  }, [website]);

  useEffect(() => {
    if (dealer && website) {
      // Set FeedviewId
      params.feedViewId = website.FeedView.id;
      // Set Conditions
      if (controlCondition === 'all' || controlVIN) {
        params.condition = ['New', 'Used', 'CPO'];
      } else {
        params.condition = [controlCondition];
      }
      // Get Cars
      if (!fetching) {
        actions.getCars(params, dealer);
      }
    }
  }, [dealer, website]);

  const generateScriptTag = () => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'prodigyButtonGroupAgent';
    document.body.appendChild(script);
  };
  return (
    <>
      <div className={styles.controlPanelContainer}>
        <Controls
          {...rest}
          controlWebsiteId={controlWebsiteId}
          controlCondition={controlCondition}
          controlVIN={controlVIN}
          controlPageTemplate={controlPageTemplate}
        />
      </div>
      <div className={styles.pageContainer}>
        <div className={styles.pageBodyContainer}>
        {fetching && (
          <Loader
            size="large"
          />
        )}
          {!fetching && error && (
            <div className={styles.errorBox}>
              <span>ERROR</span> {error}
            </div>
          )}
          {!fetching && !website && !error && <h1>Please Enter a Website Id to Begin</h1>}
          {!fetching && website && !isNil(cars) && car && controlVIN && (
            <>
              <h1>
                1 Car from {website.name} - {website.id}
              </h1>
              <StandAloneButtons widgetConfig={website.widgetConfig} />
              <BYOButton website={website} />
              <SRP
                {...rest}
                websiteId={website?.id}
                cars={[car]}
                configType={controlPageTemplate}
              />
            </>
          )}
          {!fetching && website && cars && !car && !controlVIN && (
            <>
              {controlPageTemplate !== 'standalone' && (
                <h1>
                  {cars.length} Cars from {website.name} - {website.id}
                </h1>
              )}
              {controlPageTemplate === 'standalone' && (
                <h1>
                  Stand alone products - {website.id}
                </h1>
              )}
              <StandAloneButtons widgetConfig={website.widgetConfig} />
              <BYOButton website={website} />
              <SRP {...rest} websiteId={website?.id} cars={cars} configType={controlPageTemplate} />
            </>
          )}
        </div>

        {/* <VDP /> */}
      </div>
    </>
  );
};

Page.propTypes = {
  website: PropTypes.object,
  dealer: PropTypes.string,
  cars: PropTypes.array,
  car: PropTypes.object,
  vin: PropTypes.string,
};

Page.defaultProps = {
  cars: [],
  car: null,
};

const mapStateToProps = createSelector(
  [selectorCars, selectorCar, selectorWebsite, selectorDealer, selectorFetching, selectorError],
  (cars, car, website, dealer, fetching, error) => ({
    cars,
    car,
    website,
    dealer,
    fetching,
    error,
  }),
);

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ ...carsActions, ...optionsActions }, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Page));



// WEBPACK FOOTER //
// ./src/containers/Page/Page.js